import { createAction, createReducer } from "redux-act";
import produce from "immer";

import { reducerRegistry } from "../reducerRegistry";

type DashboardLayerProps = { isVisible?: boolean };

type DashboardLayerPayload = DashboardLayerProps & { name: string };

export type DashboardState = {
  layers: Record<string, DashboardLayerProps>;
};

export const reducerName = "dashboard";

const initialState: DashboardState = {
  layers: {},
};

export const setDashboardLayers = createAction<DashboardState["layers"]>(`${reducerName}/setDashboardLayers`);
export const setDashboardLayer = createAction<DashboardLayerPayload>(`${reducerName}/setDashboardLayer`);
export const reducer = createReducer({}, initialState);

reducer.on(
  setDashboardLayers,
  produce((state: DashboardState, payload: DashboardState["layers"]) => {
    state.layers = payload;
  }),
);

reducer.on(
  setDashboardLayer,
  produce((state: DashboardState, { name, ...props }: DashboardLayerPayload) => {
    state.layers[name] = state.layers[name] ? { ...state.layers[name], ...props } : props;
  }),
);

reducerRegistry.register(reducerName, reducer);
